
import Vuex from "vuex";
import Vue from "vue";
Vue.use(Vuex);

// MUTATIONS
const SET_GENERAL_INFORMATIONS = "SET_GENERAL_INFORMATIONS";
const SET_SHOW_CONFIRM_CLOSE_MESSAGE = "SET_SHOW_CONFIRM_CLOSE_MESSAGE";
const ADD_OUTPUT_FRAME = "ADD_OUTPUT_FRAME";
const DO_CONSOLE_MANIPULATION = "DO_CONSOLE_MANIPULATION";
const CLEAR_SCREEN = "CLEAR_SCREEN";
export const SET_CONSOLE_INPUT = "SET_CONSOLE_INPUT";
const SET_SERVER_STATUS = "SET_SERVER_STATUS";


import Logger from "../../shared/logger";
const LOGGER = new Logger(__filename);

import configuredAxios from "../../shared/configured-axios";
import { context } from "../../context";
import { showWarningsForUnsupportedUiTypes } from "./output/output-fragment-resolver";
import { validateMcConsole } from "./utils";
export const axios = configuredAxios;


function lookupScriptAndPath() {
	const params = (new URL(location)).searchParams;
	const path = params.get("path");
	const script = params.get("script");
	if (!path || !script) {
		LOGGER.warn("missing query params: script or path");
	}
	return { script, path };
}

/**
 * Schwerwiegender Fehler (kein "streaming"-output möglich,
 * z.B. wenn Aufgabe nicht geladen werden kann)
 */
async function _handleError({ commit }, { error }) {
	commit(SET_SHOW_CONFIRM_CLOSE_MESSAGE, false);
	if (error.response) {
		const payload = error.response.data || {};
		// create dummy fragment to display the error
		commit(ADD_OUTPUT_FRAME, {
			title: "Fehler",
			outputFragments: [{
				uiType: "INTERNAL/server-error",
				...payload.error
			}]
		});
	} else {
		// todo?
	}
}

async function _processResponse({ commit }, responseData) {
	if (responseData.clearScreen === true) {
		commit(CLEAR_SCREEN);
		commit(SET_CONSOLE_INPUT, "");
	}
	commit(DO_CONSOLE_MANIPULATION, responseData.consoleManipulation);
	let title = "";
	let outputFragments = responseData.outputFragments; 
	if (responseData.error) {
		title = "Hoppla, da ging etwas schief...";
		outputFragments = [
			{
				uiType: "INTERNAL/server-error",
				...responseData.error
			},
			...outputFragments // or ignore outputs?
		];
	}
	// Neuen OutputFrame ausgeben
	commit(ADD_OUTPUT_FRAME, {
		title: title,
		outputFragments: outputFragments 
	});
}

async function _sendInteraction({ state, commit }, payload) {
	try {
		const response = await axios.post("/json/exercise/interaction", {
			// add tracking information
			...state.trackingInfo,
			// add defaults
			cmd: null,
			form: null,
			restartExercise: false,
			// override defaults
			...payload
		});
		let json = response.data;
		await _processResponse({ commit }, json.response);
	} catch (error) {
		LOGGER.error("error on sendForm", error);
		await _handleError({ commit }, { error });
		throw error;
	}
}

export const STORE = {
	state: {
		// general informations
		showConfirmCloseMessage: true,
		trackingInfo: {
			script: null, // helloWorld
			path: null, // demo/funktionstests/
			trackingUuid: null, // some uuid from backend
		},
		logoutUrl: null, // url to exercise-logout.jsp
		layout: null, // {buttons: ["help",...], name}
		externalUrls: {},
		metaData: {},
		
		// other stuff
		serverStatus: {
			shortMessage: "Status: 200 / Server Message: OK",
			longMessage: "...",
			ok: true
		},
		
		// console status
		console: {
			consoleInput: "",
			placeHolder: "Deine Antwort",
			expectedInput: {type: "text"}
		},
		
		// outputs from mathcoach
		outputFrames: [] /* = [
            {
                title: "",  // optional
                fragments:[  {uiType, , _key},...], 
                _key
            },... 
        ] */
		
	},
	getters:{
		mcConsoleValidation(state){
			let input = state.console.consoleInput;
			let expectedInput = state.console.expectedInput;
			let errorMessage = validateMcConsole({input,expectedInput});
			return {
				message: errorMessage || "",
				isSyntacticallyValid: errorMessage === null
			};
		},
		showMcConsole(state){
			let buttons = state.layout ? state.layout.buttons : [];
			let isSubmitEnabled = buttons.indexOf("submit") >= 0;
			let isSupportEnabled = buttons.indexOf("help") >= 0;
			return isSubmitEnabled || isSupportEnabled;
		}
	},
	mutations: {
		[SET_GENERAL_INFORMATIONS](state, { path, script, trackingUuid, logoutUrl, layout, externalUrls, metaData }) {
			LOGGER.log("SET_GENERAL_INFORMATIONS", { path, script, trackingUuid, layout, externalUrls, metaData });
			state.trackingInfo = { path, script, trackingUuid };
			state.logoutUrl = `${context.baseUrl}/${logoutUrl}`;
			state.layout = layout;
			state.externalUrls = externalUrls;
			state.metaData = metaData;
		},
		// console
		[SET_CONSOLE_INPUT](state, consoleInput) {
			state.console.consoleInput = consoleInput;
		},
		[DO_CONSOLE_MANIPULATION](state, consoleManipulation){
			if(consoleManipulation.enabledButtons !== null){
				state.layout.buttons = consoleManipulation.enabledButtons;
			}
			if(consoleManipulation.expectedInput !== null){
				state.console.expectedInput = consoleManipulation.expectedInput;
			}
			if(consoleManipulation.input !== null){
				state.console.consoleInput = consoleManipulation.input;
			}
			if(consoleManipulation.placeHolder !== null){
				state.console.placeHolder = consoleManipulation.placeHolder;
			}
		}, 
		// server status
		[SET_SERVER_STATUS](state, { shortMessage, longMessage, ok }) {
			state.serverStatus.shortMessage = shortMessage;
			state.serverStatus.longMessage = longMessage;
			state.serverStatus.ok = ok;
		},
		[SET_SHOW_CONFIRM_CLOSE_MESSAGE](state, showConfirmCloseMessage) {
			state.showConfirmCloseMessage = showConfirmCloseMessage;
		},
		// exercise logic
		[CLEAR_SCREEN](state) {
			state.outputFrames = [];
		},
		[ADD_OUTPUT_FRAME](state, { outputFragments, title }) {
			let time = new Date().getTime();
			function applyKeyFor(fragmentPart) {
				return function (fragment, i) {
					fragment._key = `${time}_${fragmentPart}_${i}`; // key based on time and index
					return fragment;
				};
			}
			// modify the state
			if (outputFragments && outputFragments.length > 0) {
				state.outputFrames.push({
					title,
					fragments: outputFragments.map(applyKeyFor("output")),
					_key: `${time}`
				});
			} 
		}
	},
	actions: {
		async init({ dispatch }) {
			let { path, script } = lookupScriptAndPath();
			try {
				document.title = script || "MathCoach Aufgabe";
			} catch (ex) {
				LOGGER.warn("error setting the document title: " + ex.message);
			}
			await dispatch("startup", { path, script });
		},
		async startup({ commit }, { path, script }) {
			LOGGER.log("startup", { path, script });
			try {
				const response = await axios.post("/json/exercise/startup", {
					path,
					script,
					trackingUuid: null // allowed for startup only
				});
				let json = response.data;
				// show warnings for unsupported fragments
				const developerInfos = json.developerInfos;
				if (developerInfos) {
					showWarningsForUnsupportedUiTypes(developerInfos.supportedUiTypes);
				}
				// process the response
				commit(CLEAR_SCREEN);
				commit(SET_GENERAL_INFORMATIONS, {
					path: path,
					script: script,
					trackingUuid: json.trackingUuid,
					logoutUrl: json.logoutUrl,
					layout: {
						name: json.layout.name,
                        buttons: json.layout.enabledButtons,
                        config: json.layout.config
					},
					externalUrls: json.layout.externalUrls,
					metaData: json.layout.metaData
				});
				await _processResponse({ commit }, json.response);
			} catch (error) {
				LOGGER.error("error on startup", error);
				await _handleError({ commit }, { error });
				throw error;
			}
		},
		async sendForm({ state, commit }, { form }) {
			LOGGER.log("sendForm", { form });
			await _sendInteraction({ state, commit }, { form });
		},
		async sendCmd({ commit, state }) {
			const cmd = state.console.consoleInput;
			LOGGER.log("sendCmd", { cmd });
			await _sendInteraction({ state, commit }, { cmd });
		},
		async sendRestartExercise({ commit, state }) {
			const cmd = state.console.consoleInput;
			LOGGER.log("sendRestartExercise", { cmd });
			await _sendInteraction({ state, commit }, { restartExercise: true });
		},
		async support({ state, commit }) {
			const consoleInput = state.console.consoleInput;
			LOGGER.log("support", { consoleInput });
			try {
				const response = await axios.post("/json/exercise/support", {
					...state.trackingInfo
				});
				let json = response.data;
				await _processResponse({ commit }, json.response);
			} catch (error) {
				LOGGER.error("error on support", error);
				await _handleError({ commit }, { error });
				throw error;
			}
		},
	}
};
const store = new Vuex.Store(STORE);
export default store;


axios.interceptors.response.use(
	res => {
		LOGGER.log("axios ok");
		store.commit(SET_SERVER_STATUS, {
			ok: true,
			shortMessage: "Status: 200 / OK",
			longMessage: "OK"
		});
		return res;
	},
	error => {
		LOGGER.log("axios error", error);
		if (error.response && error.response.status !== 200) {
			const message = error.response.data.error.message;
			const status = error.response.status;
			store.commit(SET_SERVER_STATUS, {
				ok: false,
				shortMessage: `Status: ${status} / <hover with mouse>`,
				longMessage: message
			});
		}
		return Promise.reject(error);
	}
);




